var Tools = require('../../deploynaut/js/tools.jsx');

var Variables = require('./variables.jsx');
Tools.install(Variables, 'Variables');

var ServerNames = require('./ServerNames.jsx');
Tools.install(ServerNames, 'ServerNames');
